import {
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { PlatformService } from '../../core/services/platform.service';
import { DateService } from '../modules/inputs/services/date.service';

@Directive({
  selector: '[dateCountDown]',
  //pure: true,
  standalone: true,
})
export class DateCountDownDirective implements OnChanges {
  @Input('dateCountDown') date!: Date;
  @Output() onTimesUp = new EventEmitter();
  oldValue?: any;
  interv: any;

  constructor(
    private dateService: DateService,
    private ref: ElementRef<HTMLImageElement>,
    private pt: PlatformService,
  ) {}

  ngOnChanges() {
    if (this.pt.isServer) return;
    if (this.oldValue == this.date) return;

    this.calculate();
  }
  calculate() {
    if (this.interv) clearInterval(this.interv);
    if (!this.date) return;

    const isTheSameDay = this.dateService.sameDay(new Date(this.date));
    this.display(isTheSameDay);
    if (isTheSameDay) {
      this.interv = setInterval(() => {
        if (this.date < new Date()) {
          this.onTimesUp.emit();
        }
        this.display(isTheSameDay);
      }, 1000);
    }
  }

  display(isTheSameDay = false) {
    if (isTheSameDay)
      this.ref.nativeElement.innerText = this.dateService.sinceFullHour(
        this.date,
      );
    else
      this.ref.nativeElement.innerText = this.dateService.sinceDate(this.date);
  }
}
